import { useState } from "react";

export const delay = async (time: number, callback: () => void | Promise<void>) => {
  const sleeper = new Promise(() => {
    setTimeout(async () => {
      await callback?.();
    }, time);
  });
  await sleeper;
};

type LoadResponse = [
  boolean, // loading
  () => void, // startLoad
  () => void, // stopLoad
  (time: number, callback: () => void | Promise<void>) => Promise<void> // add delay
]

export const useLoad = (initialLoad = true): LoadResponse => {
  const [on, setLoading] = useState<boolean>(initialLoad);
  const start = (): void => {
    setLoading(true);
  };
  const stop = (): void => {
    setLoading(false);
  };
  return [on, start, stop, delay];
};
